import React from "react";
import { styled } from '@mui/material/styles';
import { Box, useTheme, Link } from "@mui/material/";
import Container from "../Layout/Container/";
import AcceptanceMarks from "../AcceptanceMarks";

const PREFIX = 'Header';

const classes = {
  logos: `${PREFIX}-logos`
};

const StyledContainer = styled(Container)(() => ({
  [`& .${classes.logos}`]: {
    display: "inline-block",
    "& img": {
      transition: "all .2s",
    },
    "&:focus, &:hover": {
      "& img": {
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.3)",
      },
    },
  }
}));

const Header = () => {
  const theme = useTheme();

  return (
    <StyledContainer
      component="header"
      zIndex="2"
      position="fixed"
      height={62}
      top={0}
      paddingY={2}
      display="flex"
      justifyContent="center"
      boxShadow={`0px 6px 8px -7px ${theme.palette.borders.light}`}
      isWrapper={false}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        maxWidth={theme.containerMaxWidth}
      >
        <Link href={"/unionpay/"} className={classes.logos}>
          <AcceptanceMarks marks={["UP", "DCI", "DN"]} variant="xs" />
        </Link>
      </Box>
    </StyledContainer>
  );
};

export default Header;
